import * as React from 'react';
import styled from 'styled-components';
import { rem } from 'polished';
import { Link } from 'react-router';

import {
  FlexColCenter,
  FlexRowCenterVertical,
  FlexBetween,
} from '../../Defaults/Flexbox/Flexbox';
import { IconImg } from '../../Defaults/Icon/IconImg';

import { ZlataPriadkaFooterRowWrapper as FooterRowWrapper } from './FooterRowWrapper';
import { TextLink } from '../General/Text';

export interface Props {
  links: any;
}

function FooterFirstRow({ links }: Props) {
  const linksComponent =
    links &&
    links.map((l: any, index: number) => (
      <>
        <SmallLink key={l.id} to={`/${l.url}`}>
          {l.name}
        </SmallLink>
        {links[index + 1] ? <Delimeter /> : null}
      </>
    ));
  return (
    <FooterRowWrapper>
      <LinkWrapper>
        {linksComponent && linksComponent.length > 0 ? linksComponent : null}
      </LinkWrapper>
    </FooterRowWrapper>
  );
}

const LinkWrapper = styled(FlexRowCenterVertical)`
  justify-content: center;
  flex-wrap: wrap;

  ${({ theme }) => theme.mediab.l1050`
    margin: 0;
  `};
`;

const SmallLink = styled(TextLink)`
  font-weight: 500;
  margin: ${rem(8)} 0;

  &:hover,
  &:focus {
    text-decoration: underline;
  }

  ${({ theme }) => theme.mediab.m580`
    margin-top: 0;
    margin-bottom: ${rem(16)};
    flex: 1 1 100%;
    display: block;
    width: 100%;
    text-align: center;

    &:last-child {
      margin-bottom: 0;
    }
  `}
`;

const Delimeter = styled.span`
  margin: 0 ${rem(16)};
  width: ${rem(1)};
  height: ${rem(16)};
  background-color: ${({ theme }) => theme.colors.textPrimary};
  display: inline-block;

  ${({ theme }) => theme.mediab.m580`
    display: none;
  `}
`;

export { FooterFirstRow };
